import { Skeleton } from '@mui/material';

const AgentCardSkeleton = () => (
  <Skeleton
    variant="rectangular"
    width="100%"
    height="142px"
    sx={{
      borderRadius: '8px',
    }}
  />
);

export default AgentCardSkeleton;
